<template>
  <div class="columns is-centered">
    <div class="column is-two-thirds-tablet is-half-desktop">
      <p v-if="isLoading">
        {{ $t('user_invitation.acceptance_in_progress') }}
      </p>
      <div
        class="message is-small is-success animated fast fadeIn"
        v-if="invitationAccepted"
      >
        <div class="message-body">
          {{ $t('user_invitation.accepted') }}
        </div>
      </div>
      <div
        class="message is-small is-danger animated fast fadeIn"
        v-if="!!errorMessage"
      >
        <div class="message-body">{{ $t(errorMessage) }}</div>
      </div>
      <div v-if="invitationAccepted" class="login-container">
        <gradient-button
          :title="$t('user_invitation.login')"
          :is-inline="true"
          @click.native="signin()"
        >
        </gradient-button>
      </div>
    </div>
  </div>
</template>

<script>
import Auth from 'services/Auth';
import { GradientButton } from 'components/buttons';

export default {
  data() {
    return {
      invitationAccepted: false,
      errorMessage: '',
      isLoading: false,
    };
  },
  components: {
    GradientButton,
  },
  mounted() {
    this.confirmInvitation();
  },
  methods: {
    signin() {
      this.$router.push('/');
    },
    async confirmInvitation() {
      if (this.isLoading) {
        return;
      }

      this.isLoading = true;
      this.errorMessage = '';

      try {
        await Auth.acceptInvitation(this.invitationCode);
        this.invitationAccepted = true;
      } catch (err) {
        this.errorMessage = 'user_invitation.errors.acceptance_failed';
        this.invitationAccepted = false;
      } finally {
        this.isLoading = false;
      }
    },
  },

  computed: {
    invitationCode() {
      return this.$route.params.code;
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container {
  margin: 1rem 0;
  text-align: center;
}
</style>
